/* eslint-disable react/jsx-no-useless-fragment */
import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import LightboxModal from '../../../fl-components/LightboxModal';
//
import Scrollbar from '../../../components/Scrollbar';
// import LightboxModal from '../../../components/LightboxModal';
import ChatMessageItem from './ChatMessageItem';

// ----------------------------------------------------------------------

ChatMessageList.propTypes = {
  conversation: PropTypes.any,
  deleteMessage: PropTypes.func,
  isChatLoading: PropTypes.bool
};

ChatMessageList.defaultProps = {
  conversation: []
};

export default function ChatMessageList({ conversation, deleteMessage, isChatLoading }) {
  const scrollRef = useRef(null);

  const [openLightbox, setOpenLightbox] = useState(false);

  const [selectedImage, setSelectedImage] = useState(0);
  const [messageDivHeight, setMessageDivHeight] = useState(0);

  const calculateHeight = () => {
    if (conversation.length === 0) {
      setMessageDivHeight(0);
      return;
    }
    if (!document.getElementById('chat-scroll-bar')) {
      setMessageDivHeight(0);
      return;
    }
    setMessageDivHeight(
      document.getElementById('chat-scroll-bar').getElementsByClassName('simplebar-content')[0]
        .clientHeight
    );
  };

  useEffect(() => {
    const scrollMessagesToBottom = () => {
      if (scrollRef.current) {
        scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    };
    scrollMessagesToBottom();
    calculateHeight();
  }, [conversation, isChatLoading]);

  const imagesLightbox =
    conversation &&
    conversation
      .filter((messages) => messages.fileType === 'image/png')
      .map((messages) => messages.file);

  const handleOpenLightbox = (url) => {
    const selectedImage = imagesLightbox.findIndex((index) => index === url);
    setOpenLightbox(true);
    setSelectedImage(selectedImage);
  };

  return (
    <>
      {isChatLoading ? (
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          {conversation.length === 0 && (
            <Box
              sx={{
                height: '100%',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
              }}
            >
              <Typography variant="h4">No messages</Typography>
              <Typography sx={{ color: 'text.secondary' }}>
                Be the first one to start chat.
              </Typography>
            </Box>
          )}
          {conversation.length > 0 && (
            <Scrollbar
              scrollableNodeProps={{ ref: scrollRef }}
              sx={{
                p: 3,
                height: 1,
                '.simplebar-content-wrapper': {
                  display: 'flex',
                  // Here parent div has height of 650px
                  // align item property align all messages to bottom but the scroll not works while we have more message than 650 height
                  // So that's why it is checked here if we have height of simplebar-content is smaller than 600 only for that this property is applied
                  ...(messageDivHeight < 600
                    ? { alignItems: 'end' }
                    : { flexDirection: 'column-reverse' })
                },
                '.simplebar-content': { flex: 1 },
                '.simplebar-vertical': {
                  display: 'none'
                }
              }}
              id="chat-scroll-bar"
            >
              {conversation.map((message) => (
                <ChatMessageItem
                  key={message.id}
                  message={message}
                  onOpenLightbox={handleOpenLightbox}
                  deleteMessage={deleteMessage}
                  handleHeightChange={calculateHeight}
                />
              ))}
            </Scrollbar>
          )}

          <LightboxModal
            images={imagesLightbox}
            mainSrc={imagesLightbox[selectedImage]}
            photoIndex={selectedImage}
            setPhotoIndex={setSelectedImage}
            isOpen={openLightbox}
            onCloseRequest={() => setOpenLightbox(false)}
          />
        </>
      )}
    </>
  );
}
